<template>
    <div class="content2">
        <VipDialog ref="VipDialog" />

        <allTitle ref="allTitle" />
        <lockPriceUser ref="lockPriceUser" />

        <el-menu :default-active="activeMenu" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            :unique-opened="false" style="border-right: 1px solid #ebeef5;" @select="select" router
            :default-openeds="openeds">

            <div style="width: 98%;text-align: center;margin-top: 20px;position: relative;">
                <el-upload class="avatar-uploader" :show-file-list="false" :headers="headerObj"
                    action="https://www.qsou.com/zhnl/uploadFile" name="file" :before-upload="beforeUpload"
                    :on-success="handleAvatarSuccess">
                    <img :src="info.head_pic" class="imgStyle" alt="">
                    <img src="@/assets/newImg2/会员标识@1x.png" alt="" v-if="info.is_vip"
                        style="vertical-align: middle;margin-right: 3px;position: absolute;bottom: 8px;right: 54px;" />

                </el-upload>
            </div>
            <div style="text-align: center;color: #333333;margin-top: 2px;font-weight: 400;cursor: pointer;"
                @click="goNav2(info.user_id)">

                <span style="vertical-align: middle;">{{ info.user_name }}</span>
            </div>
            <div style="text-align: center;color: #227bff;font-weight: 400;margin-top: 3px;cursor: pointer;"
                v-if="!info.is_vip">
                <!-- <div v-if="info.is_vip">大V已认证</div> -->
                <div v-if="!info.is_vip" @click="getVip">大V未开通</div>
            </div>
            <div style="text-align: center;color: #227bff;font-weight: 400;margin-top: 3px;">

                <div v-if="busType == 1">{{ busObj.comName }}</div>
                <div v-if="busType == 0">企业审核中</div>
                <div v-if="busType == 2" style="cursor: pointer;" @click="goNav('/buyerCenter/amendEnterpriseInfo')">
                    企业认证未通过</div>
                <div v-if="busType == 3" style="cursor: pointer;" @click="goNav('/buyerCenter/amendEnterpriseInfo')">
                    企业未认证</div>
            </div>
            <!-- <div class="vipStyle" v-if="info.is_bus_vip == 1 && busType== 1" @mouseenter="enterDiv"
                @mouseleave="ifShow = false">
                <img src="https://videos.zhnl.com/water_mark/SupperVIP.gif" style="width: 52px; height: 17px" alt=""
                    v-if="info.is_super_vip == 1" />
                <img src="https://videos.zhnl.com/water_mark/VIP.gif" style="width: 52px; height: 18px" alt=""
                    v-else-if="info.is_bus_vip == 1" />

                <span v-if="info.is_super_vip == 1" class="vip_sty">超级黄金会员 </span>
                <span v-else-if="info.is_free_vip == 0" class="vip_sty">黄金会员(试用版) </span>
                <span v-else-if="info.is_bus_vip == 1" class="vip_sty">黄金会员</span>
                <div class="vipStyle2" v-show="ifShow">
                    <span v-if="info.is_super_vip == 1" class="vip_sty"><span>{{ info.super_vip_arr_time }} </span>
                        到期</span>
                    <span v-else-if="info.is_free_vip == 0" class="vip_sty"> <span> {{ info.bus_vip_arr_time
                            }}</span> 到期</span>
                    <span v-else-if="info.is_bus_vip == 1" class="vip_sty"><span>{{ info.bus_vip_arr_time }}</span>
                        到期</span>
                </div>
            </div> -->

            <div style="text-align: center;margin-bottom: 6px;margin-top: 2px">
                <span style="color: #333333"> 等级:LV{{ info2.vip_info?.levelId }}</span>
                <el-progress :percentage="info2.user_exp" style="padding-top: 2px;width: 60%;margin: auto">
                </el-progress>
            </div>
            <el-menu-item index="home">
                <i class="el-icon-house"></i>
                <span slot="title">首页</span>
            </el-menu-item>


            <!-- <el-menu-item index="theMessage">
                <i class="el-icon-message"></i>
                <span slot="title">消息中心</span>
            </el-menu-item>
            <el-menu-item index="theProduct">
                <i class="el-icon-receiving"></i>
                <span slot="title">产品管理</span>
            </el-menu-item>

            <el-submenu index="order" v-if="marketChekoutFlag == 1">
                <template slot="title">
                    <i class="el-icon-s-order"></i>
                    <span>我的订单</span>
                </template>
<el-menu-item-group>
    <el-menu-item index="myOrder">
        <i class="el-icon-s-order"></i>
        我的订单
    </el-menu-item>
    <el-menu-item index="carts">
        <i class="el-icon-shopping-cart-full"></i>
        购物车
    </el-menu-item>

</el-menu-item-group>
</el-submenu>

<el-menu-item index="myCollect">
    <i class="el-icon-receiving"></i>
    <span slot="title">我的收藏</span>
</el-menu-item>
<el-menu-item index="systemNotice">
    <i class="el-icon-bell"></i>
    <span slot="title">系统公告推送</span>
</el-menu-item>
<el-menu-item index="help">
    <i class="el-icon-question"></i>
    <span slot="title">帮助管理</span>
</el-menu-item>
<el-menu-item index="suppliers" v-if="marketChekoutFlag == 2">
    <i class="el-icon-edit"></i>
    <span slot="title">申请成为供应商</span>
</el-menu-item>
<el-menu-item index="attention">
    <i class="el-icon-user"></i>
    <span slot="title">关注的商家</span>
</el-menu-item> -->
            <el-submenu index="info">
                <template slot="title">
                    <i class="el-icon-user"></i>
                    <span>个人中心</span>
                </template>
                <el-menu-item-group>

                    <el-menu-item index="personal" class="winLeft">
                        个人信息
                    </el-menu-item>
                    <el-menu-item index="accountManagement" class="winLeft" v-show="info2.is_inner == 1">
                        账号管理
                    </el-menu-item>

                    <el-menu-item index="subManage" class="winLeft">
                        订阅管理
                    </el-menu-item>
                    <el-menu-item index="corVip" class="winLeft">
                        <span slot="title">认证与收益</span>
                    </el-menu-item>
                    <el-menu-item index="goodShowCase" class="winLeft">
                        好物橱窗
                    </el-menu-item>

                    <!-- <el-menu-item index="qyData"
                        v-show="distribut_type == 1 || distribut_type == 2 || distribut_type == 0">
                        <i class="el-icon-office-building"></i>
                        企业信息
                    </el-menu-item> -->

                    <!-- <el-menu-item index="integral">
                        <span slot="title">收益管理</span>
                    </el-menu-item> -->
                    <el-menu-item index="commentManage" class="winLeft">
                        <span slot="title">评论管理</span>
                    </el-menu-item>
                    <el-menu-item index="circleManage" class="winLeft">
                        <span slot="title">商圈管理</span>
                    </el-menu-item>
                    <!-- <el-menu-item index="strictStoreAdmin" v-show="info.is_see_add_goods == 1">
                        <span slot="title">严选商城</span>
                    </el-menu-item> -->

                    <!-- <el-menu-item index="priviLege" v-show="distribut_type != 1">
                        <i class="el-icon-office-building"></i>
                        开通企业会员
                    </el-menu-item> -->

                    <!-- <el-menu-item index="address">
                        <i class="el-icon-location-outline"></i>
                        地址管理
                    </el-menu-item> -->
                </el-menu-item-group>
            </el-submenu>
            <el-submenu index="info3">
                <template slot="title">
                    <i class="el-icon-magic-stick"></i>
                    <span>创作内容</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item index="publishVideo" class="winLeft">
                        <span slot="title">视频管理</span>
                    </el-menu-item>
                    <el-menu-item index="qwen" class="winLeft">
                        <span slot="title">Q文管理</span>
                    </el-menu-item>

                    <el-menu-item index="demand" class="winLeft">
                        <span slot="title">需求发布</span>
                    </el-menu-item>
                    <el-menu-item index="ideaManage" class="winLeft">
                        <span slot="title">想法发布</span>
                    </el-menu-item>
                    <el-menu-item index="questionManage" class="winLeft">
                        <span slot="title">问答管理</span>
                    </el-menu-item>
                    <el-menu-item index="specialProductManage" class="winLeft">
                        <span slot="title">特惠产品</span>
                    </el-menu-item>



                    <!-- <el-menu-item :disabled="disFalse">
                        <i class="el-icon-picture"></i>
                        <span slot="title">互动管理</span>
                    </el-menu-item>
                    <el-menu-item :disabled="disFalse">
                        <i class="el-icon-picture"></i>
                        <span slot="title">数据中心</span>
                    </el-menu-item> -->
                </el-menu-item-group>
            </el-submenu>
            <!-- <el-menu-item index="corVip">
                <i class="el-icon-s-goods"></i>
                <span slot="title">会员中心</span>
            </el-menu-item> -->
            <!-- <el-submenu index="info5" v-show="info2.is_quo == 1"> -->
            <el-submenu index="info5">
                <template slot="title">
                    <i class="el-icon-s-shop"></i>
                    <span>企业中心</span>
                </template>
                <el-menu-item-group>

                    <el-menu-item index="productPrice" class="winLeft">
                        <span slot="title">原料报价</span>
                    </el-menu-item>
                    <el-menu-item index="application" class="winLeft" v-show="info2.is_inner == 1">
                        <span slot="title">厂商管理</span>
                    </el-menu-item>

                    <el-menu-item index="markForecastList" class="winLeft" v-show="info2.is_inner == 1">
                        <span slot="title">行情预测</span>
                    </el-menu-item>
                    <el-menu-item index="pushNewsCopy" class="winLeft" v-show="info2.is_inner == 1">
                        <span slot="title">资讯管理</span>
                    </el-menu-item>
                    <el-menu-item index="weekReport" class="winLeft" v-show="info2.is_inner == 1">
                        <span slot="title">周报管理</span>
                    </el-menu-item>
                    <el-menu-item index="monthReport" class="winLeft" v-show="info2.is_inner == 1">
                        <span slot="title">月报管理</span>
                    </el-menu-item>


                    <!-- <el-menu-item index="selectStore">
                        <i class="el-icon-bank-card"></i>
                        <span slot="title">商城订单</span>
                    </el-menu-item> -->
                </el-menu-item-group>
            </el-submenu>

            <el-submenu index="info4">
                <template slot="title">
                    <i class="el-icon-s-claim"></i>
                    <span>任务学院</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item index="taskCenter" class="winLeft">
                        <span slot="title">任务中心</span>
                    </el-menu-item>
                    <!-- <el-menu-item index="sd" :disabled="disFalse">
                        <span slot="title">账号规则</span>
                    </el-menu-item> -->

                </el-menu-item-group>
            </el-submenu>





            <el-menu-item index="theMessage" class="mesStyle">
                <i class="el-icon-message"></i>
                <span>消息中心</span>
                <span
                    style="border: 1px solid red;border-radius: 100px;font-size: 12px;color: red;margin-left:6px;padding: 0px 3px;"
                    v-show="totalPage > 0">{{
                        totalPage }}</span>

            </el-menu-item>

        </el-menu>
    </div>
</template>

<script>
import { getBusManage, getUserMsg, getUserById, getUserInfosById, getBusAuth } from '@/api/user.js'
import VipDialog from './VipDialog.vue'
export default {
    data() {
        return {
            loading: null,
            headerObj: {
                token: window.localStorage.getItem('token'),
            },
            openeds: [],
            ifShow: false,
            info: {},
            info2: {},
            page: 1,
            size: 6,
            totalPage2: 0,
            distribut_type: '',
            disabled: false,
            thePath: 'home',
            userList: [],
            menShow: false,
            msgList: [],
            totalPage: 0,
            show: false,
            disFalse: true,
            classify: 2,
            busObj: {},
            busType: '',
        }
    },
    async created() {
        try {
            let user_id = localStorage.getItem('user_id')
            // let res =await this.$http('/mini/ApiConnect/switchUser')
            // let res = await this.$http('/mini/ApiConnect/userList',{user_id})
            // if (res.status == 1) {
            //     this.userList = res.result
            // }

        } catch (error) {

        }


    },
    components: { VipDialog },
    computed: {
        activeMenu() {
            let str = this.$route.path;
            let parts = str.split("/"); // 将字符串按照 "/" 分割成数组  
            let application = parts[2]; // 获取数组的第二个元素，即 "application"  
            return application;
        },
    },
    mounted() {

        this.$bus.$on('userData', (data) => {
            this.info = data.userData
        });
        this.$bus.$on("zfSuccess", (data) => {
            console.log('执行了');

            getUserById().then((res) => {
                this.info = res.data.data
            })
            this.getAuthType()
            console.log('走企业认证接口就完成了。');

        });

        this.$bus.$on('userMsg', (allData) => {
            this.totalPage = allData.userMsg.totalPage
        });
        this.$bus.$on('userLoginSuccess', (allData) => {
            this.info = allData.info
        });
        this.$bus.$on('userLoginSuccess2', (allData) => {
            this.info2 = allData.info2
            console.log(allData, 'allData----');

            if (allData.totalPage) {
                this.totalPage = allData.totalPage
            } else {
                getUserMsg({
                    msg_type: 1,
                    is_read: 0,
                    page: 1,
                    size: 10
                }).then((res) => {
                    this.totalPage = res.data.totalPage
                });
            }

        });
        this.$bus.$on('updateUser', (allData) => {
            getUserById().then((res) => {
                this.info = res.data.data
            })
        });
        let userId = window.localStorage.getItem("user_id")
        if (userId) {
            getUserById().then((res) => {
                this.info = res.data.data
            })

            this.getAuthType()

            getUserInfosById().then((res) => {
                this.info2 = res.data.data
            })
            getUserMsg({
                msg_type: 1,
                is_read: 0,
                page: 1,
                size: 10
            }).then((res) => {
                this.totalPage = res.data.totalPage
            });
        }

        this.$eventBus.$on('eventName', (data) => {
            this.totalPage = data
            // 处理事件  
        });
        let params = {
            msg_type: 1,
            is_read: 0,
            page: 1,
            size: 100000,
        }
        // getUserMsg(params).then((res) => {

        //     this.msgList = res.data.data
        //     this.totalPage = res.data.totalPage

        // })
        // getBusManage({ page: 1, size: 100 }).then((res) => {
        //     if (res.data.data.length <= 0) {
        //         this.menShow = false
        //     } else {
        //         this.menShow = true
        //     }
        // })
    },
    props: ['marketChekoutFlag'],
    watch: {
        marketChekoutFlag(newVal, old) {
            if (newVal == 2) {
                // this.thePath = 'home'
            } else {
                // this.thePath = 'message'

            }
        },
    },
    methods: {
        getAuthType() {
            getBusAuth({}).then((res) => {
                this.busObj = res.data.data
                if (res.data.data == null) {
                    this.busType = 3
                } else {
                    this.busType = res.data.data.reviewStatus
                }
            })
        },
        handleAvatarSuccess() {
            this.loading.close()

            getUserById().then((res) => {
                window.localStorage.setItem("headPic", res.data.data.head_pic);

                this.info = res.data.data
                this.showTitle('头像更换成功')

            })
        },
        showTitle(msg) {
            this.$refs.allTitle.msg = msg
            this.$refs.allTitle.routerPath = null;
            this.$refs.allTitle.dialogVisible = true;
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.showTitle("上传图片大小不能超过2MB!")
                return false;

            }


            if (file.type.includes("jpeg") || file.type.includes("png")) {
                // return ture
                this.loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255, 255, 255, 0.2)'
                });
            } else {
                this.showTitle('只能上传png、jpg文件')

                return false;
            }
        },
        enterDiv() {
            this.ifShow = true
            console.log(this.ifShow, 'ddd');

        },
        goNav(url) {
            this.$router.push(url)
        },
        goNav2(user_id) {
            const { href } = this.$router.resolve({
                path: '/creatorPage',
                query: { id: user_id }

            });
            window.open(href, "_blank");
        },
        getVip() {
            this.$refs.lockPriceUser.getCode();
        },
        goTou() {
            // if()
            this.$router.push({
                path: 'contribute'
            })
        },
        handleOpen(key, keyPath) {
        },
        handleClose(key, keyPath) {
        },
        async select(e) {
            // this.activeMenu2 = e
            // if (typeof e !== 'number') return
            if (e == 'home') {
                this.classify = 1
            } else {
                this.classify = 2
            }


        },
        hduser(id) {

            let params = {
                user_id: id
            }
            this.$http('/mini/ApiConnect/switchUser', params).then(res => {
                if (res.status == 1) {
                    localStorage.setItem('user_id', id)
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.$router.go(0)
                }
            })


        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-menu-item-group__title {
    padding: 0px !important;
}

.imgStyle {
    width: 80px;
    height: 80px;
    margin: auto;
    border-radius: 50%;
}

.winLeft {
    padding-left: 50px !important;
    // color: #81858f;
}

::v-deep .el-menu-item {
    padding-left: 50px;
    // color: #81858f;
}

// ::v-deep .el-menu-item .winLeft .is-active {
//     color: red !important;
// }

.vipStyle {
    text-align: center;
    font-weight: 400;
    margin-top: 2px;
    color: #333333;
    position: relative;

    .vipStyle2 {
        width: 100%;
        text-align: center;
        font-weight: 400;
        margin-top: 2px;
        color: #333333;
        position: absolute;
        bottom: -30px;
        z-index: 1000;
        background-color: white;
        padding: 5px;
    }
}






.content {
    width: 13vw;
    // height: 1330px;
    // margin-top: 30px !important;
    border-radius: 10px;
}

.content2 {
    // width: 13vw;
    // height: 135vh;
    // background-color: white;
    // margin-top: 30px !important;
    border-radius: 10px;
    margin-bottom: 30px;
}

.item {
    margin-top: 12px;
    margin-right: 4px;

}

.el-menu-item {
    min-width: 170px;
}
</style>